import React from "react";

interface SelectColumnFilterProps {
  filterValue: string;
  setFilter: (filterValue: string) => void;
  preFilteredRows: any;
  id: string;
}
// add type to the functional component
// export const SelectColumnFilter: React.FC<SelectColumnFilterProps> = ({
const SelectColumnFilter: React.FC<SelectColumnFilterProps> = ({
  filterValue,
  setFilter,
  preFilteredRows,
  id,
}) => {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row: { values: { [x: string]: unknown } }) => {
      options.add(row.values[id]);
    });
    // @ts-ignore
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value);
      }}
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default SelectColumnFilter;
